import { lazy, Suspense } from 'react';
import Hero from '@/components/Hero';
import TrustBar from '@/components/TrustBar';
import Seo from '@/seo/Seo';
import clinic from '@/data/clinic';

const WhyAyurveda = lazy(() => import('@/components/WhyAyurveda'));
const Conditions = lazy(() => import('@/components/Conditions'));
const Treatments = lazy(() => import('@/components/Treatments'));
const PatientStories = lazy(() => import('@/components/PatientStories'));
const Quiz = lazy(() => import('@/components/Quiz'));
const DoctorProfile = lazy(() => import('@/components/DoctorProfile'));
const Contact = lazy(() => import('@/components/Contact'));

const Home = () => {
  const title = 'Siddhayu Ayurvedic Clinic & Panchakarma Centre | Dr. Ankit Sahu | Nala Sopara';
  const description = 'Authentic Ayurvedic treatment in Nala Sopara by Dr. Ankit Sahu (BAMS, MCIM registered). Panchakarma, Agnikarma, Shirodhara, Nadi Parikshan & 15+ treatments. 4.9★ Google Rating.';

  return (
    <>
      <Seo
        title={title}
        description={description}
        path="/"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: clinic.name,
          url: clinic.siteUrl,
          potentialAction: {
            '@type': 'SearchAction',
            target: clinic.siteUrl + '/treatments?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <Hero />
      <TrustBar />
      <Suspense fallback={null}>
        <WhyAyurveda />
        <Conditions />
        <Treatments />
        <PatientStories />
        <Quiz />
        <DoctorProfile />
        <Contact />
      </Suspense>
    </>
  );
};

export default Home;
